<sz-app-shell>
  <sz-top-bar />

  <div class="drill-detail">
    @if (data(); as r) {
      <sz-page-title
        [title]="r.drill.name"
        size="xl"
        [showBack]="true"
        [actionItems]="actionItems()"
        [actionsAriaLabel]="'drills.detail.actionsAria' | translate"
        (actionSelect)="onActionSelect($event)" />

      <div class="drill-detail__pills">
        <sz-type-pill [type]="r.drill.typeLabel === 'Live' ? 'Live' : 'Dry'" />
        <sz-pill variant="outline">{{ r.drill.scoringLabel }}</sz-pill>
        @if (r.drill.shotsCount !== null) {
          <sz-pill variant="outline">
            {{ 'drills.detail.shotsCountPill' | translate: { count: r.drill.shotsCount } }}
          </sz-pill>
        }
        @if (r.drill.favorite) {
          <sz-pill variant="outline">{{ 'drills.detail.favoritePill' | translate }}</sz-pill>
        }
      </div>

      @if (r.drill.description) {
        <sz-card variant="subtle" class="drill-detail__description">
          <div class="drill-detail__description-head">
            <span class="drill-detail__description-label">{{ 'drills.detail.descriptionLabel' | translate }}</span>
          </div>
          <p class="drill-detail__description-text">{{ r.drill.description }}</p>
        </sz-card>
      }

      @if (r.drill.id) {
        <sz-button class="drill-detail__view-progress" variant="secondary" [fullWidth]="true" (click)="goToProgress()">
          <sz-icon name="chart" [size]="16" />
          {{ 'drills.detail.viewProgress' | translate }}
        </sz-button>
      }

      @if (bestSessionRows().length > 0) {
        <sz-section-head [label]="'drills.detail.bestSessionsLabel' | translate" [count]="bestSessionRows().length" />
        <div class="drill-detail__rows">
          @for (row of bestSessionRows(); track row.sessionId) {
            <sz-row-card variant="flat" class="drill-detail__row-clickable" (click)="goToSession(row.sessionId)">
              <sz-ic-circle szRowLead size="sm" accent="ghost">
                <sz-icon name="flame" [size]="14" class="drill-detail__flame-icon" />
              </sz-ic-circle>
              <div class="drill-detail__row-body">
                <div class="drill-detail__row-primary">{{ row.primaryLabel }}</div>
                <div class="drill-detail__row-meta">{{ row.relativeDateLabel }} · {{ row.runsLabel }}</div>
              </div>
              <sz-icon szRowEnd name="arrow-right" [size]="16" />
            </sz-row-card>
          }
        </div>
      }

      <sz-section-head
        [label]="'drills.detail.recentSessionsLabel' | translate"
        [count]="r.drill.recentSessions.length" />

      @if (recentRows().length === 0) {
        <p class="drill-detail__empty">{{ 'drills.detail.noSessions' | translate }}</p>
      } @else {
        <div class="drill-detail__rows">
          @for (row of recentRows(); track row.sessionId) {
            <sz-row-card variant="flat" class="drill-detail__row-clickable" (click)="goToSession(row.sessionId)">
              <sz-ic-circle szRowLead size="sm" accent="ghost">
                <sz-icon name="clock" [size]="14" />
              </sz-ic-circle>
              <div class="drill-detail__row-body">
                <div class="drill-detail__row-primary">{{ row.primaryLabel }}</div>
                <div class="drill-detail__row-meta">{{ row.relativeDateLabel }} · {{ row.runsLabel }}</div>
              </div>
              <sz-icon szRowEnd name="arrow-right" [size]="16" />
            </sz-row-card>
          }
        </div>
      }
    } @else {
      <div class="drill-detail__skeleton">
        <sz-skeleton shape="text" width="60%" height="28px" />
        <div class="drill-detail__skeleton-pills">
          <sz-skeleton shape="text" width="64px" height="22px" radius="999px" />
          <sz-skeleton shape="text" width="84px" height="22px" radius="999px" />
          <sz-skeleton shape="text" width="72px" height="22px" radius="999px" />
        </div>
        <sz-skeleton shape="block" height="80px" />
        <sz-skeleton shape="block" height="44px" />
        <sz-skeleton shape="text" width="40%" height="14px" />
        <sz-skeleton shape="block" height="64px" />
        <sz-skeleton shape="block" height="64px" />
      </div>
    }
  </div>

  @if (data(); as r) {
    <sz-cta-bar variant="floating">
      <sz-button variant="primary" [fullWidth]="true" (click)="startSession()">
        <sz-icon name="play" [size]="16" />
        {{ 'common.startSession' | translate }}
      </sz-button>
    </sz-cta-bar>
  }
</sz-app-shell>
